import { Component } from '@angular/core';

@Component({
  selector: 'hhsg-footer',
  template: `
    <div class="footer-copyright">
      <p> &copy; {{currentYear}} Huron Consulting Group Inc. and affiliates. All rights reserved.</p>
    </div>
  `,
  styleUrls: ['footer.component.scss']
})
export class HhsgSharedFooterComponent {
  currentYear: number = new Date().getFullYear();
  constructor() { }
}
